export default __webpack_public_path__ + "components/page-header/static/icon-heart--white-214a930954153d56b6d1e053c6cb4855.svg";